<template>
  <div class="form-group">
    <div class="grey mb5">{{ label ?? name }}</div>
    <v-select :deselect-from-dropdown="true" v-bind="$attrs" @open="fetchOptions" :placeholder="placeholder"
      :filterable="false" :name="name" v-validate="rules" v-model="inputValue" :disabled="disabled" label="text"
      :options="options" @search="debounceSearch" :close-on-select="!$attrs.multiple"
      @input="$emit('input', inputValue)" :searchable="searchable">
    </v-select>
    <small class="text-danger text-sm" v-show="errors.has(name)">
      {{ errors.first(name) }}
    </small>
  </div>
</template>

<script>
export default {
  name: 'FieldAsyncSelect',
  props: {
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      default: null
    },
    value: {
      type: [String, Number, Array, Object],
      default: ''
    },
    rules: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchable: {
      type: Boolean,
      default: true
    },
    placeholder: {
      type: String,
      default: 'Choose One'
    },
    optionsHandlers: {
      type: Function,
      required: true
    },
  },
  data() {
    return {
      inputValue: this.value,
      options: [],
      isLoading: false
    };
  },
  watch: {
    inputValue(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.inputValue = val;
    }
  },
  inject: ['$validator'],
  methods: {
    debounceSearch(query, loading) {
      loading(true)
      clearTimeout(this.debounce)
      this.debounce = setTimeout(async () => {
        await this.fetchOptions(query)
        loading(false)
      }, 500)
    },
    async fetchOptions(query = '') {
      this.options = []
      this.options = await this.optionsHandlers({ query })
    },
    onInput() {
      this.$emit('input', this.inputValue)
    }
  }
};
</script>
